import useWindowHeight from './useWindowHeight';
import { useAuxiliaryClassNameLayout } from './useAuxiliaryClassNameLayout';
import { useScrollToSection } from './useScrollToSection';

export const usePageHooks = props => {
  useWindowHeight();
  useAuxiliaryClassNameLayout([props.layout, props.extraClassName]);
  useScrollToSection();

  return null;
};
